import SearchIcon from '@mui/icons-material/Search';
import { TextField, Theme } from '@mui/material';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import BoxDrawer from 'components/BoxDrawer';
import IconButtonCancel from 'components/Buttons/IconButtonCancel';
import { SpinnerIndicator } from 'components/CallServer';
import { GridEx } from 'components/MuiExtras/Grid/GridEx';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiLink from 'components/MuiExtras/MuiLink';
import MuiPagination from 'components/MuiExtras/MuiPagination';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import MuiMuted from 'components/MuiExtras/Typography/MuiMuted';
import { TextPluralization } from 'components/TextPluralization';
import UsernameInspect from 'components/UsernameInspect';
import { Formaters } from 'lib/Formarters';
import { PublicationType, SystemRoles } from 'models/ApiEnums';
import { DashboardPublicationModel, PagedResult } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RouteComponentProps, withRouter } from 'react-router';
import { RoutePaths } from 'routes/RouteConfig';
import Session from 'services/Session';
import { getPublicationUrl } from 'views/Timeline/Components/FeedHelpers';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const styles = (theme: Theme) => createStyles({
    table: {
        margin: 0,
        padding: 0
    },
    tableCell: {
        paddingBottom: theme.spacing(2)
    }
});

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    ds: PagedResult<DashboardPublicationModel>;
    offset: number;
    loading: boolean;
    lastError: any;
    searchText: string;
}

interface IProps {
    title: string;
    subtitle: string;
    detailCountText?: {
        singular: string;
        plural: string;
    };
    answersFromUserId?: string;
    showCreationDate?: boolean;
    showPublishDate?: boolean;
    onClose: () => void;
    onGetData: (searchText: string, offset: number, take: number) => Promise<PagedResult<DashboardPublicationModel>>;
}

type Props = IProps & WithStyles<typeof styles> & RouteComponentProps & WithTranslation;

const rowsPerPage = 15;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class PublicationListDrawer extends React.PureComponent<Props, IState> {

    private searchRef: any = null;

    constructor(props: Props) {
        super(props);
        this.state = {
            ds: null,
            offset: 0,
            loading: true,
            lastError: null,
            searchText: ""
        };
    }

    private getData(offset: number) {

        this.setState({ loading: true });

        this.props.onGetData(this.searchRef ? this.searchRef.value : null, offset, rowsPerPage)
            .then((result: PagedResult<DashboardPublicationModel>) => {
                this.setState({ ds: result, loading: false, lastError: null, offset: offset });
            })
            .catch((error) => {
                this.setState({ ds: null, lastError: error, loading: false, offset: 0 });
            });
    }

    private handleSearch(e: React.KeyboardEvent<HTMLDivElement>) {
        if (e.keyCode == 13) this.getData(0);
    }

    private renderContent() {
        const { ds, loading } = this.state;
        const { classes, t } = this.props;

        return (
            <GridEx container fullHeight direction="column" wrap="nowrap">
                <GridEx>

                    <MuiContainer>
                        <TextField
                            fullWidth
                            placeholder={t("Common.Input.Placeholder.SearchFor")}
                            value={this.state.searchText}
                            onChange={() => this.setState({ searchText: this.searchRef.value })}
                            onKeyDown={(e) => this.handleSearch(e)}
                            onBlur={() => this.getData(0)}
                            inputRef={(ref) => this.searchRef = ref}
                            InputProps={
                                {
                                    startAdornment: <SearchIcon />,
                                    endAdornment: this.state.searchText != ""
                                        ? <IconButtonCancel
                                            size="small"
                                            onClick={
                                                () => {
                                                    this.setState({ searchText: "" }, () => this.getData(0));
                                                }
                                            } />
                                        : null
                                }
                            }
                        />
                    </MuiContainer>

                </GridEx>
                <GridEx item xs overflow="auto">
                    {
                        loading
                            ? <SpinnerIndicator />
                            : (
                                <table className={classes.table}>
                                    <tbody>
                                        {
                                            ds.items.map((v, index) => {

                                                var url: string = null;
                                                var target: string = null;
                                                var onClick: () => void = null;

                                                if (v.publicationType == PublicationType.Course && (v.creatorId == Session.user.id || Session.hasRole(SystemRoles.CourseManager))) {
                                                    onClick = () => {
                                                        this.props.history.push(RoutePaths.CourseAdminList, { editCourseId: v.publicationId });
                                                    };
                                                }
                                                else {
                                                    target = "_blank";
                                                    url = getPublicationUrl(v.publicationId, v.publicationType);

                                                    if (v.publicationType == PublicationType.Question && this.props.answersFromUserId) {
                                                        url += "?afu=" + this.props.answersFromUserId;
                                                    }
                                                }

                                                return (
                                                    <tr key={index}>
                                                        {/*
                                                        <td className={classes.tableCell}>
                                                            {
                                                                v.thumbnailUrl
                                                                    ? <img src={v.thumbnailUrl} width="48" height="48" />
                                                                    : <IconCreatePublication color="muted" size="3x" />
                                                            }
                                                        </td>
                                                        */}

                                                        <td className={classes.tableCell}>
                                                            <MuiLink color="secondary" href={url} target={target} onClick={onClick}>{v.title}</MuiLink>

                                                            <MuiMuted>
                                                                <small>
                                                                    {
                                                                        v.creatorName &&
                                                                        <div>
                                                                            <MuiMuted>
                                                                                Publicado por <UsernameInspect user={{ userId: v.creatorId, name: v.creatorName }} />
                                                                                {v.isInstitutional === true && <span> ({t("Common.Feed.Literals.InstitutionalText")})</span>}
                                                                            </MuiMuted>
                                                                        </div>
                                                                    }

                                                                    {
                                                                        v.creationDate && this.props.showCreationDate &&
                                                                        <div>
                                                                            <MuiMuted> {Formaters.relativeTime(v.creationDate)} </MuiMuted>
                                                                        </div>
                                                                    }

                                                                    {
                                                                        v.publishDate && this.props.showPublishDate &&
                                                                        <div>
                                                                            <MuiMuted> {Formaters.relativeTime(v.publishDate)} </MuiMuted>
                                                                        </div>
                                                                    }

                                                                    {
                                                                        v.detailCount != null &&
                                                                        <div>
                                                                            <TextPluralization count={v.detailCount} singular={`{count} ${this.props.detailCountText.singular}`} plural={`{count} ${this.props.detailCountText.plural}`} />
                                                                        </div>
                                                                    }
                                                                </small>
                                                            </MuiMuted>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }
                                    </tbody>
                                </table>
                            )
                    }
                </GridEx>

                {
                    !loading &&
                    <GridEx item>
                        <MuiPagination
                            limit={rowsPerPage}
                            offset={this.state.offset}
                            total={ds.total}
                            onClick={(e, offset) => this.getData(offset)}
                        />
                    </GridEx>
                }
            </GridEx>
        );
    }

    public componentDidMount() {
        this.getData(0);
    }

    public render() {
        const { title, subtitle, onClose } = this.props;

        return (
            <BoxDrawer
                open
                overflow="hidden"
                onClose={() => onClose()}
                title={title}
                subtitle={subtitle}
            >
                <MuiPaper fullHeight elevation={0}>
                    {this.renderContent()}
                </MuiPaper>
            </BoxDrawer>
        );
    }
}

export default withRouter(withTranslation()(withStyles(styles)(PublicationListDrawer)));